export const getNumberOfSelected = (competitorsList) => competitorsList?.filter(({ selected }) => selected).length;

export const isInValidDomainWithoutSubFolder = (domain: string): boolean => {
    let domainToCheck = domain;
    if (!domain.includes("http")) {
        domainToCheck = "http://" + domain;
    }
    let urlObj;
    try {
        urlObj = new URL(domainToCheck.trim());
    } catch (_e) {
        return true;
    }
    return urlObj.origin !== domainToCheck;
};
